import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const PasswordReset = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const validatePassword = (pwd) => {
    if (pwd.length < 8) return 'Password must be at least 8 characters long';
    if (!/[A-Z]/.test(pwd)) return 'Password must contain at least one uppercase letter';
   // if (!/[0-9]/.test(pwd)) return 'Password must contain at least one number';
   // if (!/[!@#$%^&*]/.test(pwd)) return 'Password must contain at least one special character';
    return '';
  };
const {id} = useParams()
const nav = useNavigate()
  const handleSubmit = async(e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    try {
            let g = {
id,
pass:confirmPassword
    }
      await axios.post('https://plsuploader-7381434a72f8.herokuapp.com/users/passreset',g)
.then(res => {
    toast.success('Password Change Successfull')
nav('/',{replace:true})

})
.catch(err => console.log(err))
 
      setPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError('Failed to reset password. Please try again.');
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4 text-center">Reset Password</h2>
      <div className='py-[10px]'>An apology is offered for the inconvenience caused by the forced password reset on the account. This action can be disruptive and frustrating.
<br /><br /><span className='text-[1.1rem] font-bold'>Why the password was reset:</span><br />
The highest level of account security is a priority. To protect data, passwords were proactively reset for all accounts as a security measure to help enforce this priority.  Thank you for understanding.</div>
      <form onSubmit={handleSubmit} className='mt-[20px]'>
        <div className="mb-4">
          <label htmlFor="password" className="block text-sm font-bold text-gray-700">
            New Password
          </label>
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm"
            >
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>
        </div>

        <div className="mb-4">
          <label htmlFor="confirmPassword" className="block text-sm font-bold text-gray-700">
            Confirm Password
          </label>
          <input
            type={showPassword ? 'text' : 'password'}
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
        {success && <p className="text-green-500 text-sm mb-4">{success}</p>}

        <button
          type="submit"
          className="w-full bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Reset Password
        </button>
      </form>
    </div>
  );
};

export default PasswordReset;